import { ColorVals } from './types';

export const veeqoColors: { [key: string]: ColorVals } = {
  orange: '#FF6200',
  black: '#05192D',
  white: '#FFFFFF',
  blue: '#2578FF',
  transparent: 'transparent',
};

export type VeeqoColorsType = typeof veeqoColors;
